import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import vortoMark from 'assets/images/vorto-mark.png';

const Logo = () => {
  const siteInfo = useSelector((state) => state.siteInfo);
  const [failedLogo, setFailedLogo] = useState(null);
  const customLogo = siteInfo.logo && siteInfo.logo !== failedLogo;
  if (customLogo)
    return (
      <Box
        component="img"
        src={siteInfo.logo}
        alt={siteInfo.system_name || '涡拓网关'}
        onError={() => setFailedLogo(siteInfo.logo)}
        sx={{ height: 36, maxWidth: 180, objectFit: 'contain' }}
      />
    );
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, whiteSpace: 'nowrap' }}>
      <Box
        component="img"
        src={vortoMark}
        alt="涡拓 Vorto"
        width={40}
        height={40}
        sx={{ display: 'block', bgcolor: '#0e1014', borderRadius: 1, flexShrink: 0 }}
      />
      <Box sx={{ textAlign: 'left' }}>
        <Typography
          component="span"
          sx={{ display: 'block', fontSize: 21, fontWeight: 700, lineHeight: 1.15, letterSpacing: '-0.04em', color: 'text.primary' }}
        >
          Vorto
        </Typography>
        <Typography component="span" sx={{ display: 'block', mt: 0.25, fontSize: 9, letterSpacing: '0.12em', color: 'text.secondary' }}>
          AI GATEWAY
        </Typography>
      </Box>
    </Box>
  );
};
export default Logo;
